/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListLinks } from "../funcs/skillsListLinks.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListSkillLinksRequest,
  ListSkillLinksResponse,
  ListSkillLinksSecurity,
  TargetKind,
} from "../models/operations/listskilllinks.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type SkillLinksQueryData = ListSkillLinksResponse;

export type SkillLinksInfiniteQueryData = PageIterator<
  ListSkillLinksResponse,
  { cursor: string }
>;

export type SkillLinksPageParams = PageIterator<
  ListSkillLinksResponse,
  { cursor: string }
>["~next"];

export function prefetchSkillLinks(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillLinksRequest | undefined,
  security?: ListSkillLinksSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSkillLinksQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchSkillLinksInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSkillLinksRequest | undefined,
  security?: ListSkillLinksSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildSkillLinksInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as SkillLinksPageParams,
    getNextPageParam: (previousPage: SkillLinksInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildSkillLinksQuery(
  client$: GramCore,
  request?: ListSkillLinksRequest | undefined,
  security?: ListSkillLinksSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SkillLinksQueryData>;
} {
  return {
    queryKey: queryKeySkillLinks({
      skillId: request?.skillId,
      mcpServerId: request?.mcpServerId,
      metaMcpServerId: request?.metaMcpServerId,
      targetKind: request?.targetKind,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillLinksQueryFn(
      ctx,
    ): Promise<SkillLinksQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListLinks(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildSkillLinksInfiniteQuery(
  client$: GramCore,
  request?: ListSkillLinksRequest | undefined,
  security?: ListSkillLinksSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, SkillLinksPageParams>,
  ) => Promise<SkillLinksInfiniteQueryData>;
} {
  return {
    queryKey: queryKeySkillLinksInfinite({
      skillId: request?.skillId,
      mcpServerId: request?.mcpServerId,
      metaMcpServerId: request?.metaMcpServerId,
      targetKind: request?.targetKind,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function skillLinksQuery(
      ctx,
    ): Promise<SkillLinksInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(skillsListLinks(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(skillsListLinks(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeySkillLinks(
  parameters: {
    skillId?: string | undefined;
    mcpServerId?: string | undefined;
    metaMcpServerId?: string | undefined;
    targetKind?: TargetKind | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listLinks", parameters];
}

export function queryKeySkillLinksInfinite(
  parameters: {
    skillId?: string | undefined;
    mcpServerId?: string | undefined;
    metaMcpServerId?: string | undefined;
    targetKind?: TargetKind | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listLinks", "infinite", parameters];
}
